import React, { useState, useEffect } from 'react';
import history from '../../utils/history';
import { gateway } from '../../utils/api';
import { fetchSapBankSlipOrders } from '../../business/bankSlips';
import NavBarSuperior from '../NavBarSuperior/NavBarSuperior';
import Loading from '../Loading/Loading';
import { Container, BoxInfo, ContianerNavBar, NavLit, NextButton, BoxActions, Main } from './styles';

import OrderItem from './OrderItem';
import EmptyState from './EmptyState';

const IMG_LIT = require('../../images/lit.png');

export default function PaymentHistory({ subscriptionsStatus = 'ACTIVE', handleContinue, buttonTitle, goToOnboarding }) {
  const {
    location: { state }
  } = history;

  const [invoicesPerSubscription, setInvoicesPerSubscription] = useState([]);
  const [activerOrder, setActiveOrder] = useState(0);
  const [fetchLoading, setFetchLoading] = useState(true);
  const [loadFailed, setLoadFailed] = useState(false);

  async function fetchInvoices() {
    setFetchLoading(true);
    setLoadFailed(false);

    // As duas origens são independentes: a falha de uma não pode esconder a outra.
    const sapOrdersPromise = fetchSapBankSlipOrders();

    let invoiceOrders = [];

    try {
      const email = localStorage.getItem('ra');
      const response = await gateway.post(
        '/webbff/lit_app_web/payment/invoice/getUserInvoices',
        {
          ownerEmail: email,
        }
      );

      if (response && response.length > 0) {
        invoiceOrders = response;
      }
    } catch (error) {
      const status = error && error.response ? error.response.status : undefined;

      // Aluno sem contrato de boleto: o endpoint responde 404/400 em vez de
      // lista vazia. Isso não é falha — é só ausência de boleto.
      if (status === 404 || status === 400) {
        console.error('Nenhum boleto de contrato para este aluno:', status);
      } else {
        console.error('Erro ao buscar boletos do contrato:', error);
        setLoadFailed(true);
      }
    }

    const sapOrders = await sapOrdersPromise;

    setInvoicesPerSubscription([...invoiceOrders, ...sapOrders]);
    setFetchLoading(false);
  }

  useEffect(() => {
    fetchInvoices();
  }, []);

  function logout() {
    history.push('/logout');
  }

  return (
    <Container>
      <ContianerNavBar>
        {state &&
        !state.nextPageParams.editingPayment &&
        state.nextPageParams.fromPayment ? (
          <NavLit className="navbar navbar-lit navbar-expand-lg bg-gradient-lit">
            <a className="navbar-brand">
              <img src={IMG_LIT} alt="logo_lit" style={{ width: '100px' }} />
            </a>
            <button type="button" onClick={() => logout()}>
              SAIR
            </button>
          </NavLit>
        ) : (
          <NavBarSuperior />
        )}
      </ContianerNavBar>
      <Main>
        {fetchLoading && <Loading width={45} />}
        {!fetchLoading && invoicesPerSubscription.length === 0 && (
          <BoxInfo>
            <EmptyState
              variant={loadFailed ? 'error' : 'empty'}
              onRetry={fetchInvoices}
            />
          </BoxInfo>
        )}
        {!fetchLoading &&
          invoicesPerSubscription.length > 0 &&
          invoicesPerSubscription.map((subsciption, index) => {
            return (
              <BoxInfo key={index}>
                <div>
                  <OrderItem
                    key={`order-${0}`}
                    order={subsciption}
                    index={index}
                    activerOrder={activerOrder}
                    setActiveOrder={i => setActiveOrder(i)}
                  />
                </div>
              </BoxInfo>
            );
          })}
          {subscriptionsStatus !== "ACTIVE" && 
          !fetchLoading && (
            <BoxActions style={{ marginTop: 30 }}>
              <NextButton type="button" onClick={() => {
                if(typeof handleContinue === 'function'){
                  handleContinue();
                }
              }}>
                {buttonTitle}
              </NextButton>
              {typeof goToOnboarding === 'function' && (
                <NextButton type="button" onClick={() => {
                  goToOnboarding();
                }}>
                  Preencher onboarding
                </NextButton>
              )}
          </BoxActions>
        )}
      </Main>
      
    </Container>
  );
}
